import React from "react";

import {
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
} from "@mui/material";

import { useSurveyLanguage } from "../../helpers/contexts/surveyLanguage";

const LANGUAGES = [
  { value: "en", label: "EN" },
  { value: "es", label: "ES" },
  { value: "fr", label: "FR" },
];

const SurveyLanguageToggle = () => {
  const { language, setLanguage } = useSurveyLanguage();
  const { palette } = useTheme();

  const buildButtonStyle = (buttonLanguage) => ({
    color: language === buttonLanguage ? "white" : palette.text.primary,
    backgroundColor:
      language === buttonLanguage ? palette.primary.main : "white",
    fontWeight: 700,
    padding: "4px 14px",
    border: `1px solid ${palette.primary.main}`,
  });

  return (
    <ToggleButtonGroup
      value={language}
      exclusive
      onChange={(_, newLang) => {
        if (newLang) {
          setLanguage(newLang);
        }
      }}
      size="small"
      style={{ boxShadow: "0 2px 6px rgba(0,0,0,0.2)" }}
    >
      {LANGUAGES.map(({ value, label }) => (
        <ToggleButton
          key={value}
          value={value}
          style={buildButtonStyle(value)}
        >
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
export default SurveyLanguageToggle;
